<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog">
        <el-form ref="formValidate" :model="model" label-width="120px">
            <el-form-item label="昵称：" prop="nickname">
                <span>{{model.nickname}}</span>
            </el-form-item>
            <!-- <el-form-item label="微信头像：" prop="face">
                <el-avatar shape="square" :size="100" fit="fill" :src="model.face"></el-avatar>
            </el-form-item> -->
            <el-form-item label="姓名：" prop="realname">
                <span>{{model.realname}}</span>
            </el-form-item>
            <el-form-item label="编号：" prop="realname">
                <span>{{model.member_code}}</span>
            </el-form-item>
            <el-form-item label="车辆数量：" prop="realname">
                <span>{{model.car_count}}</span>
            </el-form-item>
            <el-form-item label="手机号：" prop="cellphone">
                <span>{{model.cellphone}}</span>
            </el-form-item>            
            <el-form-item label="邮箱：" prop="username">
                <span>{{model.username}}</span>
            </el-form-item>
            <el-form-item label="注册时间：" prop="regtime">
                <span>{{ formatDate(model.regtime, "yyyy-mm-dd HH:mm:ss") }}</span>
            </el-form-item>
            <el-form-item label="最后登录时间：" prop="lastlogin">
                <span>{{ formatDate(model.lastlogin, "yyyy-mm-dd HH:mm:ss") }}</span>
            </el-form-item>
            <el-form-item label="关注公众号：" prop="is_sub">
                <span>{{ transEnu(model.is_sub, "yesNo")}}</span>
            </el-form-item>
            <el-form-item label="积分：" prop="is_sub">
                <span>{{model.point}}</span>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="closeDialog" size="medium">关 闭</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'

export default {
    name: 'memberInfo',
    mixins: [editutil],
    data() {
        return {
            model: {
                nickname: '',
                realname: '',
                sex: '',
                cellphone: '',
                face: '',
                regtime: '',
                lastlogin: '',
                state: '',
                is_sub: '',
            },
            getObj:{
                url:'/api/admin/member/info',
                data:{
                    key:'id',
                    value:''
                }
            },
            enu_name: ['yesNo'],
        };
    },
    methods: {}
};
</script>